/**
 * 抵押信息查询路由配置
 */
export default {
  path: '/home/info-search/yhdyxx-query',
  name: 'yhdyxx-query',
  component: () => import('iebdc/views/yhdyxx-query/index.vue'),
  meta: {
    label: '抵押信息查询',
    isNotMenu: true,
    permission: 'IEBDC:SY:DZZZ',
    construction: 'IEBDC:SY:XXCX:DZZZ:SFZJ',
    activeMenu: '/home/info-search',
    icon: require('../../assets/images/wdzz.png'),
  },
};
